import { FieldConfig } from "./field-config";

const entityType: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "propertyItemTypeId",
            label: "Property Type",
            validators: {}
        },
        {
            name: "propertyPropertyTypeIds",
            label: "Secondary Property Types",
            validators: {}
        }
    ],
    customFields: [],
}
const primaryInformation: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "propertyItemTypeId",
            label: "Property Type",
            validators: {}
        },
        {
            name: "tags",
            label: "Tags",
            validators: {}
        },
        {
            name: "itemNumber",
            label: "Item Number",
            validators: {}
        },
        {
            name: "agencyPropertyCodeId",
            label: "Agency Property Code",
            validators: {}
        },
        {
            name: "ucrPropertyTypeId",
            label: "UCR Property Code",
            validators: {}
        },
        {
            name: "nibrsPropertyDescCodeId",
            label: "NIBRS Property Description Code",
            validators: {}
        },
        {
            name: "estimatedValue",
            label: "Estimated Value",
            validators: {}
        },
        {
            name: "actualValue",
            label: "Actual Value",
            validators: {}
        }
    ],
    customFields: [],
  };

  const otherItem: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "brand",
            label: "Brand",
            validators: {}
        },
        {
            name: "model",
            label: "Model",
            validators: {}
        },
        {
            name: "color",
            label: "Color",
            validators: {}
        },
        {
            name: "serialNumber",
            label: "Serial Number",
            validators: {}
        },
        {
            name: "amount",
            label: "Amount",
            validators: {}
        },
        {
            name: "unit",
            label: "Unit",
            validators: {}
        },
        {
            name: "description",
            label: "Description",
            validators: {}
        }
    ],
    customFields: [],
  };

  const drug: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "drugType",
            label: "Drug Type",
            validators: {}
        },
        {
            name: "drugQuantity",
            label: "Drug Quantity",
            validators: {}
        },
        {
            name: "drugMeasurement",
            label: "Drug Measurement",
            validators: {}
        },
        {
            name: "useFor3DrugTypes",
            label: "Use For 3+ Drug Types",
            validators: {}
        },
        {
            name: "description",
            label: "Description",
            validators: {}
        }
    ],
    customFields: [],
  };

  const stolen: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "stolenValue",
            label: "Stolen Value",
            validators: {}
        },
        {
            name: "stolenDate",
            label: "Stolen Date",
            validators: {}
        },
        {
            name: "stolenLocationId",
            label: "Stolen Location",
            validators: {}
        },
        {
            name: "useIncidentLocation",
            label: "Use Incident Location",
            validators: {}
        }
    ],
    customFields: [],
  };

  const recovered: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "recoveredValue",
            label: "Recovered Value",
            validators: {}
        },
        {
            name: "recoveredDate",
            label: "Recovered Date",
            validators: {}
        },
        {
            name: "recoveredLocationId",
            label: "Recovered Location",
            validators: {}
        },
        {
            name: "useIncidentLocation",
            label: "Use Incident Location",
            validators: {}
        }
    ],
    customFields: [],
  };

  const found: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "foundDate",
            label: "Found Date",
            validators: {}
        },
        {
            name: "foundDescription",
            label: "Found Description",
            validators: {}
        },
        {
            name: "foundLocationId",
            label: "",
            validators: {}
        },
        {
            name: "useIncidentLocation",
            label: "Use Incident Location",
            validators: {}
        }
    ],
    customFields: [],
  };

  const firearm: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "firearmManufacturerId",
            label: "Make",
            validators: {}
        },
        {
            name: "firearmModel",
            label: "Model",
            validators: {}
        },
        {
            name: "serialNumber",
            label: "Serial Number",
            validators: {}
        },
        {
            name: "firearmClassificationId",
            label: "Type",
            validators: {}
        },
        {
            name: "caliberId",
            label: "Caliber",
            validators: {}
        },
        {
            name: "barrelLength",
            label: "Barrel Length",
            validators: {}
        },
        {
            name: "finishId",
            label: "Finish",
            validators: {}
        },
        {
            name: "description",
            label: "Description",
            validators: {}
        },
        {
            name: "idObliterated",
            label: "Identification Obliterated",
            validators: {}
        },
        {
            name: "atfNotified",
            label: "ATF Notified",
            validators: {}
        },
        {
            name: "atfExam",
            label: "ATF Exam",
            validators: {}
        }
    ],
    customFields: [],
  };

  const ncicData: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "ncicNumber",
            label: "NCIC Number (NIC)",
            validators: {}
        },
        {
            name: "enteredOn",
            label: "Date/Time Entered",
            validators: {}
        },
        {
            name: "enteredById",
            label: "Entered By",
            validators: {}
        },
        {
            name: "cancelledOn",
            label: "Date/Time Cancelled",
            validators: {}
        },
        {
            name: "cancelledById",
            label: "Cancelled By",
            validators: {}
        },
    ],
    customFields: [],
  };

  const damages: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "date",
            label: "Date",
            validators: {}
        },
        {
            name: "value",
            label: "Value",
            validators: {}
        },
        {
            name: "comment",
            label: "Comment",
            validators: {}
        }
    ],
    customFields: [],
  };

  const nonFirearmWeapon: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "weaponType",
            label: "Type",
            validators: {}
        },
        {
            name: "description",
            label: "Description",
            validators: {}
        }
    ],
    customFields: [],
  };

  const taggedPrimaryInformation: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "tagNumber",
            label: "Tag Number",
            validators: {}
        },
        {
            name: "submittedBy",
            label: "Submitted By",
            validators: {}
        },
        {
            name: "submittedDateTime",
            label: "Submitted Date/Time",
            validators: {}
        },
        {
            name: "approved",
            label: "Restricted",
            validators: {}
        },
        {
            name: "projectedDispositionDate",
            label: "Projected Disposition Date",
            validators: {}
        },
        {
            name: "projectedDispositionTimePeriodDays",
            label: "Days",
            validators: {}
        },
        {
            name: "projectedDispositionTimePeriodMonths",
            label: "Months",
            validators: {}
        },
        {
            name: "projectedDispositionTimePeriodYears",
            label: "Years",
            validators: {}
        }
    ],
    customFields: [],
  };

  const courtData = {
    fields: [
        {
            name: "courtId",
            label: "Court",
            validators: {}
        },
        {
            name: "projectedCourtDate",
            label: "Projected Court Date",
            validators: {}
        },
        {
            name: "courtClosedDate",
            label: "Court Close Date",
            validators: {}
        },
        {
            name: "courtTrackingNumber",
            label: "Court Tracking Number",
            validators: {}
        },
    ],
    customFields: [],
  };

  const disposition = {
    fields: [
        {
            name: "sentToPerson",
            label: "Sent To Person",
            validators: {}
        },
        {
            name: "sentToPersonId",
            label: "",
            validators: {}
        },
        {
            name: "sentToOrgId",
            label: "",
            validators: {}
        },
        {
            name: "sentToOrg",
            label: "Sent To Organization",
            validators: {}
        },
        {
            name: "sentDate",
            label: "Sent Date",
            validators: {}
        },
        {
            name: "letterReturnDate",
            label: "Letter Return Date",
            validators: {}
        },
        {
            name: "releasedToPersonId",
            label: "",
            validators: {}
        },
        {
            name: "releasedToPerson",
            label: "Released To Person",
            validators: {}
        },
        {
            name: "releasedToOrgId",
            label: "",
            validators: {}
        },
        {
            name: "personAuthorizedForRelease",
            label: "Person(s) Authorized For Release",
            validators: { maxLength: 200}
        },
        {
            name: "releasedToOrg",
            label: "Released To Organization",
            validators: {}
        },
        {
            name: "destructionReasonId",
            label: "Destruction Reason",
            validators: {}
        },
        {
            name: "destructionMethodId",
            label: "Destruction Method",
            validators: {}
        },
        {
            name: "approvedForFinalDisposition",
            label: "Approved For Final Disposition",
            validators: {}
        },
        {
            name: "prosecutor",
            label: "Prosecutor",
            validators: {}
        },
        {
            name: "propertyDispositionId",
            label: "Disposition Status",
            validators: {}
        },
        {
            name: "soldToPersonId",
            label: "",
            validators: {}
        },
        {
            name: "soldToPerson",
            label: "Sold To Person",
            validators: {}
        },
        {
            name: "soldToOrganizationId",
            label: "",
            validators: {}
        },
        {
            name: "soldToOrganization",
            label: "Sold To Organization",
            validators: {}
        },
        {
            name: "saleAmount",
            label: "Sale Amount",
            validators: {}
        },
        {
            name: "finalDate",
            label: "Date Time",
            validators: {}
        },
        {
            name: "dispositionById",
            label: "Disposition By",
            validators: {}
        },
        {
            name: "witnessById",
            label: "Witness",
            validators: {}
        },
        {
            name: "authorizedById",
            label: "Authorized By",
            validators: {}
        },
        {
            name: "releaseComment",
            label: "Release Comment",
            validators: {}
        },
    ],
    customFields: [],
  };

  const chainOfCustody: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "dateTime",
            label: "Date and Time",
            validators: {required: true}
        },
        {
            name: "locationActionId",
            label: "Location Action",
            validators: {}
        },
        {
            name: "temporaryHoldLocationId",
            label: "Temporary Hold Location",
            validators: {}
        },
        {
            name: "facilityId",
            label: "Facility",
            validators: {}
        },
        {
            name: "aisleId",
            label: "Aisle",
            validators: {}
        },
        {
            name: "shelfId",
            label: "Shelf",
            validators: {}
        },
        {
            name: "binId",
            label: "Bin",
            validators: {}
        },
        {
            name: "containerId",
            label: "Container",
            validators: {}
        },
        {
            name: "releasedById",
            label: "Released By",
            validators: {}
        },
        {
            name: "acceptedById",
            label: "Accepted By",
            validators: {}
        },
        {
            name: "reasonId",
            label: "Reason",
            validators: {}
        },
        {
            name: "statusId",
            label: "Status",
            validators: {}
        },
        {
            name: "estimatedReturnDateTime",
            label: "Estimated Return",
            validators: {}
        },
        {
            name: "actualReturnDateTime",
            label: "Actual Return",
            validators: {}
        },
        {
            name: "comment",
            label: "Comment",
            validators: {}
        },
        {
            name: "propertyInPropertyRoom",
            label: "In Property Room",
            validators: {required: true}
        },
    ],
    customFields: [],
  };

  const propertyAudit: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "auditId",
            label: "Audit Id",
            validators: {}
        },
        {
            name: "auditNumber",
            label: "Audit Number",
            validators: {}
        },
        {
            name: "auditFacilityId",
            label: "Audit Facility",
            validators: {required: true}
        },
        {
            name: "auditTypeId",
            label: "Audit Type",
            validators: {required: true}
        },
        {
            name: "auditCriteria",
            label: "Criteria",
            validators: {}
        },
        {
            name: "auditAisleId",
            label: "Aisle",
            validators: {}
        },
        {
            name: "auditShelfId",
            label: "Shelf",
            validators: {}
        },
        {
            name: "auditBinId",
            label: "Bin",
            validators: {}
        },
        {
            name: "auditContainerId",
            label: "Container",
            validators: {}
        },
    ],
    customFields: [],
  }

  const releaseArrestDetainee: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "chargingId",
            label: "ChargingId",
            validators: {}
        },
        {
            name: "charging",
            label: "Charging",
            validators: {}
        },
        {
            name: "selectDetaineePropertyToPrint",
            label: "Release Selected Property(s)",
            validators: {}
        },
        {
            name: "releasedToPerson",
            label: "Release To",
            validators: {required: true}
        },
        {
            name: "releasedBy",
            label: "Released By",
            validators: {required: true}
        },
        {
            name: "witnessedBy",
            label: "Released Witness",
            validators: {}
        },
        {
            name: "signatureStatus",
            label: "Signature For Release",
            validators: {required: true}
        },
        {
            name: "releasedOnDate",
            label: "Released On",
            validators: {required: true}
        },
        {
            name: "comment",
            label: "Release Comment",
            validators: {}
        },
        {
            name: "reportHeader",
            label: "Report Header",
            validators: {}
        },
        {
            name: "printPageNumbers",
            label: "Print Page Numbers",
            validators: {}
        },
        {
            name: "printFooter",
            label: "Print Footer",
            validators: {}
        },
        {
            name: "printImages",
            label: "Print Images",
            validators: {}
        },
        {
            name: "printHeader",
            label: "Print Header on Each Page",
            validators: {}
        },
        {
            name: "avoidPageBreakInSections",
            label: "Avoid Page Break In Sections",
            validators: {}
        },
    ],
    customFields: [],
  }

  const releaseProperty: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "selectPropertyReleaseSearchType",
            label: "Release Search Type",
            validators: {}
        },
        {
            name: "selectPropertyReleaseOwnerType",
            label: "Release Owner Type",
            validators: {}
        },
        {
            name: "property",
            label: "Property",
            validators: {}
        },
        {
            name: "propertyOwnerId",
            label: "Property Owner Id",
            validators: {}
        },
        {
            name: "propertyOwner",
            label: "Owner",
            validators: {}
        },
        {
            name: "selectPropertyToPrint",
            label: "Release Selected Property(s)",
            validators: {}
        },
        {
            name: "releasedToOrg",
            label: "Released To Organization",
            validators: {}
        },
        {
            name: "releasedToPerson",
            label: "Release To",
            validators: {required: true}
        },
        {
            name: "releasedOnDate",
            label: "Final Disposition Date",
            validators: {required: true}
        },
        {
            name: "propertyDispositionId",
            label: "Disposition Status",
            validators: {required: true}
        },
        {
            name: "dispositionBy",
            label: "Disposition By",
            validators: {}
        },
        {
            name: "witnessedBy",
            label: "Released Witness",
            validators: {}
        },
        {
            name: "authorizedBy",
            label: "Authorized By",
            validators: {}
        },
        {
            name: "comment",
            label: "Release Comment",
            validators: {}
        },
        {
            name: "reportHeader",
            label: "Report Header",
            validators: {}
        },
        {
            name: "printPageNumbers",
            label: "Print Page Numbers",
            validators: {}
        },
        {
            name: "printFooter",
            label: "Print Footer",
            validators: {}
        },
        {
            name: "printImages",
            label: "Print Images",
            validators: {}
        },
        {
            name: "printHeader",
            label: "Print Header on Each Page",
            validators: {}
        },
        {
            name: "avoidPageBreakInSections",
            label: "Avoid Page Break In Sections",
            validators: {}
        },
    ],
    customFields: [],
  }

  const releaseBookingDetainee: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "chargingId",
            label: "ChargingId",
            validators: {}
        },
        {
            name: "charging",
            label: "Charging",
            validators: {}
        },
        {
            name: "selectDetaineePropertyToPrint",
            label: "Release Selected Property(s)",
            validators: {}
        },
        {
            name: "releasedToPerson",
            label: "Release To",
            validators: {required: true}
        },
        {
            name: "releasedBy",
            label: "Released By",
            validators: {required: true}
        },
        {
            name: "witnessedBy",
            label: "Released Witness",
            validators: {}
        },
        {
            name: "signatureStatus",
            label: "Signature For Release",
            validators: {required: true}
        },
        {
            name: "releasedOnDate",
            label: "Released On",
            validators: {required: true}
        },
        {
            name: "comment",
            label: "Release Comment",
            validators: {}
        },
        {
            name: "reportHeader",
            label: "Report Header",
            validators: {}
        },
        {
            name: "printPageNumbers",
            label: "Print Page Numbers",
            validators: {}
        },
        {
            name: "printFooter",
            label: "Print Footer",
            validators: {}
        },
        {
            name: "printImages",
            label: "Print Images",
            validators: {}
        },
        {
            name: "printHeader",
            label: "Print Header on Each Page",
            validators: {}
        },
        {
            name: "avoidPageBreakInSections",
            label: "Avoid Page Break In Sections",
            validators: {}
        },
    ],
    customFields: [],
  }


  const releaseAgencyTransferProperty: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "property",
            label: "Property Search",
            validators: {}
        },
        {
            name: "selectPropertyToPrint",
            label: "Selected Property(s)",
            validators: {}
        },
        {
            name: "dateTime",
            label: "Date and Time",
            validators: {required: true}
        },
        {
            name: "locationActionId",
            label: "Location Action",
            validators: {}
        },
        {
            name: "releasedById",
            label: "Released By",
            validators: {required: true}
        },
        {
            name: "acceptedById",
            label: "Accepted By",
            validators: {}
        },
        {
            name: "reasonId",
            label: "Reason",
            validators: {required: true}
        },
        {
            name: "statusId",
            label: "Status",
            validators: {required: true}
        },
        {
            name: "estimatedReturnDateTime",
            label: "Estimated Return",
            validators: {}
        },
        {
            name: "comment",
            label: "Release Comment",
            validators: {}
        },
        {
            name: "reportHeader",
            label: "Report Header",
            validators: {}
        },
        {
            name: "printPageNumbers",
            label: "Print Page Numbers",
            validators: {}
        },
        {
            name: "printFooter",
            label: "Print Footer",
            validators: {}
        },
        {
            name: "printImages",
            label: "Print Images",
            validators: {}
        },
        {
            name: "printHeader",
            label: "Print Header on Each Page",
            validators: {}
        },
        {
            name: "avoidPageBreakInSections",
            label: "Avoid Page Break In Sections",
            validators: {}
        },
    ],
    customFields: [],
  }

  export const propertyPrimaryInformationFields = {
    fields: [...primaryInformation.fields]
  }

  export const propertyOtherItemFields = {
    fields: [...otherItem.fields]
  }

  export const propertyDrugFields = {
    fields: [...drug.fields]
  }
  
  export const propertyStolenFields = {
    fields: [...stolen.fields]
  }

  export const propertyRecoveredFields = {
    fields: [...recovered.fields]
  }

  export const propertyFoundFields = {
    fields: [...found.fields]
  }

  export const propertyFirearmFields = {
    fields: [...firearm.fields]
  }

  export const propertyNcicData = {
    fields: [...ncicData.fields]
  }

  export const propertyDamages = {
    fields: [...damages.fields]
  }

  export const propertyNonFirearmWeaponFields = {
    fields: [...nonFirearmWeapon.fields]
  }

  export const propertyTaggedPrimaryInformation = {
    fields: [...taggedPrimaryInformation.fields]
  }

  export const propertyCourtData = {
    fields: [...courtData.fields]
  }

  export const propertyDisposition = {
    fields: [...disposition.fields]
  }

  export const propertyChainOfCustody = {
    fields: [...chainOfCustody.fields]
  }

  export const propertyEntityType = {
    fields: [...entityType.fields]
  }

  export const propertyRoomInventoryAudit = {
    fields: [...propertyAudit.fields]
  }

  export const propertyReleaseArrestDetainee = {
    fields: [...releaseArrestDetainee.fields]
  }

  export const propertyRelease = {
    fields: [...releaseProperty.fields]
  }

  export const propertyReleaseBookingDetainee = {
    fields: [...releaseBookingDetainee.fields]
  }

  export const propertyReleaseAgencyTransfer = {
    fields: [...releaseAgencyTransferProperty.fields]
  }